export const environment = {
  production: false,
  // apiUrl: 'https://localhost:44305'
  apiUrl: 'https://app.fazendasantavitoria.com.br/api'
};